import { Nullable } from 'cng-common/models/utils'

export const calculateKeyInitiativeEstimateSales = (
  funnelSize: Nullable<number>,
  conversionRate: Nullable<number>
): Nullable<number> => {
  if (funnelSize === null || conversionRate === null) {
    return null
  }

  return (funnelSize * conversionRate) / 100
}
